import { PlatformSettingsNotificationsDto } from './platform-settings-notifications.dto';

/**
 * Partial update for platform settings. Absent fields are left untouched.
 */
export class UpdatePlatformSettingsDto {
	notifications?: PlatformSettingsNotificationsDto | null;
}
